import React from 'react';
import { ImageViewer } from 'antd-mobile';

interface TransportPhotoViewerProps {
    photoUrl: string | null | undefined;
    onClose: () => void;
}

const TransportPhotoViewer: React.FC<TransportPhotoViewerProps> = ({ photoUrl, onClose }) => {
    if (!photoUrl) return null;

    return (
        <ImageViewer
            image={photoUrl}
            visible={true}
            onClose={onClose}
            renderFooter={() => null}
        />
    );
};

export default TransportPhotoViewer;


